import React from 'react';
import Header from '../../components/header/Header';
import Navbar from '../../components/navbar/Navbar';
import BLOG1 from '../../assets/img/blog_1.jpeg';
import BLOG3 from '../../assets/img/blog_3.jpeg';
import BLOG5 from '../../assets/img/blog_5.jpeg';
import BLOG6 from '../../assets/img/blog_6.jpeg';
import BLOG7 from '../../assets/img/blog_7.jpeg';
import BLOG8 from '../../assets/img/blog_8.gif';
import BLOG9 from '../../assets/img/blog_9.jpeg';
import BLOG10 from '../../assets/img/blog_10.jpg';
import BLOG11 from '../../assets/img/blog_11.jpeg';
import BLOG12 from '../../assets/img/blog_12.jpeg';
import BLOG13 from '../../assets/img/blog_13.jpeg';
import BLOG14 from '../../assets/img/blog_14.jpeg';
import BLOG15 from '../../assets/img/blog_15.jpeg';
import BLOG16 from '../../assets/img/blog_16.jpeg';


const BlogScreen = () => {
    return (
        <>
            <Header />
            <Navbar />
            <div className='container max-w-screen-xl mx-auto px-4 md:px-2 mt-24 sen-font'>
                <h2 className='text-3xl font-extrabold text-center mb-5'>Handicrafts in India – Checkout the variety and craftsmanship</h2>

                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className=''>
                        <img src={BLOG1} alt="" className='' />
                    </div>
                    <div className='col-span-2'>
                        The term ‘handicraft’ essentially entails processing raw materials manually, or with the help of basic tools to create useful or decorative products from clay, rock, paper, stone, etc which are crafted by skilled artisans. The amount of skill, patience and precision that goes into the making of these beautiful pieces is commendable.

                        From time immemorial, the handicrafts of India have been loved and respected worldwide and have left everyone awestruck. Blessed with an affluent cultural heritage that’s reflected within the intricacy of its handicrafts, India is surely a true blue shopper’s paradise.
                    </div>
                </div>

                {/* <div className='my-7'>
                    <img src={BLOG2} alt="" className='w-full' />
                </div> */}


                <div className='text-xl font-bold mt-8 mb-4'>
                    Here is a list of different types of Indian Handicrafts that we have described in this article for you:
                </div>


                <div className='font-bold'>
                    1.Wooden handicrafts <br />
                    2.Clay & pottery <br />
                    3.Leather <br />
                    4.Jute<br />
                    5.Shell<br />
                    6.Metal Handicrafts<br />
                    7.Bamboo & Cane<br />
                    8.Stone<br />
                    9.Bone & Horn<br />
                </div>
                

                <div className='text-xl font-extrabold my-8'>
                    Role and Importance of Indian Handicraft Industry
                </div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4'>
                    <div>
                        <img src={BLOG3} alt="" className='w-96' />
                    </div>
                    <div className='col-span-2'>
                        <div>
                            Handicrafts are a medium to hold and conserve the rich traditional art forms and heritage along with the talents which are associated with the people’s history and lifestyle. The country is blessed with innumerable highly skilled artisans. They have increased the eminence of Indian handicrafts round the globe. They are hugely important in terms of the economic development of the country.
                        </div>
                        <div>
                            The Indian handicrafts industry incorporates around 7 million artisans and 67000 exporters, who endorse regional art and craftsmanship in domestic as well as global markets. These artisans generally comprise of women and other people belonging to the rural area of India. In other words, this industry employs a number of people from the weaker sections of the society, who earn their livelihood from their creative pieces of art and this way India is guiding the preservation of its artisans, its art and its handicrafts.
                        </div>
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>1. WOODWORK</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>


              


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className='col-span-2'>
                        Handicrafts are considered as one of the oldest traditions of the world. Wooden handicrafts are made by decorating or carving the wood to create beautiful items. Every craftsman creates a unique handicraft according to their individual talent. India is considered as the land of tradition and culture. Handicrafts form an integral part of India’s rich and unique customs. The craft council of India has given a report by saying, “Handicraft is the second-largest source of employment in the country, after agriculture. Yet India’s hand industries are in a crisis of misunderstanding.”
                        <br /><br />
                        This inheritance or we say Indian handicrafts history of making unique and beautiful handicrafts has been passed from one generation to another. India has a unique variety of awestruck jewellery, hand-made paintings and beautiful woodcraft. These pleasing items can only be found in India.  
                    </div>
                    <div>
                        <img src={BLOG6} alt="" className='md:w-96 w-full' />
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>2. CLAY CRAFT or POTTERY</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>

                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div>
                        <img src={BLOG7} alt="" className='w-full' />
                    </div>
                    <div className='col-span-2'>
                        Pottery is considered to be the most sensual form of all arts. The tradition of handmade pottery is prevailing in India since the time of the Indus Valley Civilization, clay craft or pottery is said to be one of the most primitive forms of handicrafts in India. Artists engaged in pottery are called “Kumhaars”.
                        Besides its world famous Terracotta form, pottery has got different forms like red ware, grey ware and black ware. 
                        <br />
                        The word Terracotta has been derived from Latin and Italian words – ‘Terra’, which is Latin for ‘earth’ or ‘soil’, and ‘Cotta’, which is Italian for ‘statue’. Thus Terracotta work is the art of creating statues/figurines from mud, clay or earth. Numerous terracotta artefacts dating back to 3300BC have been recovered from Harappan civilisation Sites.
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>3. LEATHER HANDICRAFT</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className='col-span-2'>
                        The age-old and well-established convention of leather skill in India is established by ancient sages and ascetics. The leather craft tradition dates back to Indus Valley civilisation. In the ancient times, the artisans were skilled at making clothes and footwear but also in making caps, bags, saddles, shield etc of leather. India is one of the top sellers worldwide for its leather products.
                    </div>
                    <div>
                        <img src={BLOG9} alt="" className='w-full' />
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>4. JUTE HANDIRAFT</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div>
                        <img src={BLOG10} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                    <div className='col-span-2'>
                        Jute is used to make a wide variety of accessories. Bags, various kinds of hammocks, folders, bottle covers, tea coasters, dolls, wall hangings, pen holders, door mats, belts and even mobile covers are made using jute. It also used widely in manufacturing different types of packaging material for agricultural and industrial products. Its coarse quality has a unique charm while heavy texture, natural colors and twill kind of body typify it earthiness.
                        In India jute craft is impregnated with a rich past. Before transmuted as a commodity used for commercial exploration jute had its utilitarian usage amidst the globe to make household and farm implements such as ropes, hand made clothes, wall hangings, etc. The jute craft has developed in India centring the Eastern India. Bengal reveled in sacks and saris made of jute were usually used in the Middle Age producing maximum jute globally.
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>5. SHELL HANDICRAFT</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className='col-span-2'>
                        Shell Craft has always been in great demand in India and have religious and social significance. The ornaments made out of shells are cherished by the people of all strata of the society. Since time immemorial, shells are the most colourful and fascinating objects known to man ever, other than gems. Shells are basically the hard outer protective covering of sea creatures. Empty shells are found in abundance in sea beaches and are utilized to craft outstanding utilitarian and decorative items. They serve as ornaments, musical instruments, drinking cups and many more artefacts. Shells have unending aesthetic uses too and are used extensively in rituals and religious observances. Shells such as Giant clam, Green mussel and Oyster support edible shell fishery and a few like Scallops, Clams and Cockles are burnt in kiln to produce edible lime.
                    </div>
                    <div>
                        <img src={BLOG11} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>6. METAL HANDICRAFTS</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div>
                        <img src={BLOG12} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                    <div className='col-span-2'>
                        Metals are usually associated with hardness, sturdiness and solid utility. The use of metals brings to mind construction, large industries and a sense of formidable resistance. But metals are malleable, which means they can be shaped, pressed or hammered without breaking or even cracking.
                        <br />
                        This quality of metals makes it craftsman’s delight. And hence Indian metal crafts are popular all over the world. Quite contrary to their sturdy image, metal craft in India exude a combination of style, artistry, as well as, dependability.
                        <br />
                        <span className='font-bold'>Metal crafts in India</span> date back to the Indus Valley Civilization. The discovery of the Dancing Girl sealed the fact that people of the sub-continent region were masters at moulding metal since long. The legacy of metal works is seen till date in bronze statues of the Chola kingdom or the iron pillar at Mehrauli in Delhi made during Ashoka’s time.
                    </div>
                </div>


                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className='col-span-2'>
                        Bidar is the centre for the manufacture of these unique metal handicrafts which developed during the 14th century, where ‘bidriware’ gets its name. This metal is a blackened alloy of copper and zinc inlaid with fine sheets of pure silver. This makes it one of the most important south Indian handicrafts exports and is commonly prized as a symbol of wealth in many places across the world. So many products are made from the metal, including pitchers, bangles, boxes, statues, masks, buttons, and many more. Tradition is to inlay various leaves, flowers, human figures, geometric designs, and stylised poppy plants with flowers.
                    </div>
                    <div>
                        <img src={BLOG13} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>7. BAMBOO AND CANE HANDICRAFT</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>



                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div>
                        <img src={BLOG14} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                    <div className='col-span-2'>
                        The bamboo crafts of Tamil Nadu primarily have a variety of household items, home decor items, and other purposes. The artisans use the fibers of cane or rattan and Tamil reed bamboo. Tamil Nadu is a state where the raw material is in abundance in addition to the artisans, an added advantage.
                        <br />
                        The major products made from bamboo include baskets, dolls, toys, mats, trays, flower baskets, shopping bags, folding fans, and more. Another popular item in Tamil Nadu comprises window screens made of bamboo slats tied with strings, plain or colored. These bamboo window screens are known as ‘chiks’ by the locals.
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>8. STONE HANDICRAFT</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>



                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div className='col-span-2'>
                        Stone craft existed in India since ancient times. Till today, excavations reveal carved stones which are 3000 years old. The stone craft of ancient times mainly involved carving of stones to make small weapons. Arrow heads, spears javelin points and hammers are made out of stone. These tools were used both for hunting and cooking. As the time passed, stone carving evolved into a form of art.
                        <br /><br />
                        The famous rock cut temples of Pallavas in Mahabalipuram occupy a special place in Indian history. The sculptures of Arjuna asking for penance on one knee, the hunting of pigeons, stag scratching its nose with hind leg, etc. found in these temples are so alive.
                    </div>
                    <div>
                        <img src={BLOG15} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                </div>


                <div className='text-green-700 text-2xl uppercase tracking-wider my-10'>9. BONE AND HORN</div>
                <div className='text-xl uppercase my-5'>HISTORY</div>



                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 my-7'>
                    <div>
                        <img src={BLOG16} alt="" className='md:w-96 h-60 object-cover w-full' />
                    </div>
                    <div className='col-span-2'>
                        The horn-bone handicraft products made in Sambhal are immensely popular. The raw material used for making these craft items is procured from dead animals that makes this industry environment friendly. Sambhal’s horn and bone products are known all over the world. In fact, the horn-bone handicrafts made here are exported to various countries. Sambhal offers a wide range of decorative horn-bone handicrafts that are available in different attractive looks, designs and patterns. Indeed artisans of Sambhal are known worldwide for making spell-bounded range of decorative items that are popular in not only national but also in international markets.
                    </div>
                </div>







            </div>
        </>
    )
}

export default BlogScreen;